export default (that) => [
  {
    title: that.$l('table_label_orderImport_rowNum') || '行数',
    field: 'rowNum',
    width: 60,
    align: 'center',
    fixed: 'left',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_errorMsg') || '错误信息',
    field: 'errorMsg',
    width: 200,
    align: 'left',
    headerAlign: 'center',
    fixed: 'left',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_hxPreOrderNo') || '订单编号',
    field: 'hxPreOrderNo',
    width: 140,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_preOrderDate') || '下单日期',
    field: 'preOrderDate',
    width: 110,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_jdOrderType') || '订单类型',
    field: 'jdOrderType',
    width: 100,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_jdGoodsType') || '产品类型',
    field: 'jdGoodsType',
    width: 100,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_jdPcm') || '采控经理',
    field: 'jdPcm',
    width: 100,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_jdPm') || '产品经理',
    field: 'jdPm',
    width: 100,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_temphxSkuNo') || '京东SKU编码',
    field: 'temphxSkuNo',
    width: 140,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_tempGoodsName') || 'SKU名称',
    field: 'tempGoodsName',
    width: 280,
    align: 'left',
    headerAlign: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_channelEanNo') || '渠道条码号',
    field: 'channelEanNo',
    width: 140,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_ncNo') || 'NC',
    field: 'ncNo',
    width: 140,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_purchasePrice') || '采购单价',
    field: 'purchasePrice',
    width: 90,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_purchaseQty') || '下单数量',
    field: 'purchaseQty',
    width: 90,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_inCtnQty') || '装箱入数',
    field: 'inCtnQty',
    width: 90,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_ctnQty') || '采购箱数',
    field: 'ctnQty',
    width: 90,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_tailCtnQty') || '采购尾箱',
    field: 'tailCtnQty',
    width: 90,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_totalCtnQty') || '采购总箱数',
    field: 'totalCtnQty',
    width: 90,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_subAmount') || '金额小计',
    field: 'subAmount',
    width: 90,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_operateName') || '运营人员',
    field: 'operateName',
    width: 140,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_ftyLeadTime') || '生产周期',
    field: 'ftyLeadTime',
    width: 90,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title:
      that.$l('table_label_orderImport_expectDeliveryDate') || '预计交付日期',
    field: 'expectDeliveryDate',
    width: 110,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_avgSevenDayQty') || '7日均销量',
    field: 'avgSevenDayQty',
    width: 90,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_ftyMoq') || 'MOQ',
    field: 'ftyMoq',
    width: 90,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title:
      that.$l('table_label_orderImport_lessThanMoq') || '下单数量小于MOQ原因',
    field: 'lessThanMoq',
    width: 200,
    align: 'left',
    headerAlign: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderImport_remark') || '备注',
    field: 'remark',
    width: 200,
    align: 'left',
    headerAlign: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
]
